export default "/images/vendor/flag-icon-css/flags/4x3/ai.svg?c4699001b99c1638c76545a8f3c90d13";